import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { MenuWidget } from "../../../models/menu-widget.model";
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, AfterViewInit {

  @Input() data!: MenuWidget[];
  @Input() model!: string;
  @Input() name!: string;
  static compName = 'Menu';

  collapsed: boolean = true;


  constructor(private location: Location, private router: Router) { }

  ngOnInit(): void {
    // Inizializza tutte le voci come chiuse
  }

  ngAfterViewInit(): void {
    this.findListItems();
  }


  handleClick() {
  }

  redirectToLink(link: string | undefined | null) {
    if (link) {
      // Effettua il redirect alla URL specificata
      this.router.navigateByUrl(link);
    }
  }

  toggleCollapse(event: MouseEvent, link: string | undefined | null) {
    // Verifica se il link è definito e se il clic non è stato fatto sull'area che apre/chiude
    if (link && !this.isCollapseOpen(event)) {
      event.preventDefault(); // Prevenire l'azione predefinita del link
      this.router.navigateByUrl(link); // Esegui il redirect
    }
  }

  isCollapseOpen(event: MouseEvent): boolean {
    // Controlla se il target dell'evento è un'area che dovrebbe aprire/chiudere il collapse
    return (event.target as HTMLElement).closest('.list-item-title-icon-wrapper') !== null;
  }


  findListItems() {
    const classCss = 'active';
    document.querySelectorAll('.' + classCss).forEach(el => el.classList.remove(classCss));
    let doc = document.querySelectorAll('a.list-item.medium');
    //console.log(doc)
    doc.forEach(el => {
      if (el.getAttribute('href')?.toLowerCase() === "/" + this.getFragments()[1].toLowerCase()) {
        //console.log("trovato", el);
        //console.dir(el)
        el.classList.add(classCss);

        this.findParentComponent(el, 'a.list-item.medium');
      }
    });
  }

  findParentComponent(element: Element, componentName: string): void {
    //console.log("findParentComponent", element, componentName);
    document.querySelectorAll('.' + "show").forEach(el => el.classList.remove("show"));

    let firstAccordion;
    let secondAccordion;
    let thirdAccordion;
    //console.log(element.parentNode?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode);
    firstAccordion = element.parentElement?.parentElement?.parentElement ? element.parentElement?.parentElement?.parentElement : null;
    if (firstAccordion) {
      secondAccordion = firstAccordion?.parentElement?.parentElement?.parentElement ? firstAccordion?.parentElement?.parentElement?.parentElement : null;
    }
    if (secondAccordion) {
      thirdAccordion = secondAccordion?.parentElement?.parentElement?.parentElement ? secondAccordion?.parentElement?.parentElement?.parentElement : null;
    }

    //console.log(firstAccordion);
    if (firstAccordion) {
      (firstAccordion as Element).classList.add("show");
    }
    if (secondAccordion) {
      (secondAccordion as Element).classList.add("show");
    }
    if (thirdAccordion) {
      (thirdAccordion as Element).classList.add("show");
    }

  }


  getFragments(): string[] {
    return this.location.path().split("/").map(fragment => fragment.toLowerCase());
  }
}
